import { EventSourceHandler } from '@sellsy/sse';

export default class SummaryGeneratedEventSourceHandler extends EventSourceHandler {
    constructor() {
        super();
        this.type = 'corporation.summary.generated';
    }

    handle(event) {
        window.EventBus.emit('summary:generated', event.data);
    }
}
